import { createStyles } from '@material-ui/core';
export var checkboxStyles = function (theme) {
    return createStyles({
        root: {
            color: theme.palette.text.secondary,
            opacity: '60%',
            '&:hover': {
                color: theme.palette.secondary.main,
                opacity: '100%',
            },
            '& .MuiSvgIcon-root': {
                width: '18px',
                height: '18px',
            },
        },
        checked: {
            color: theme.palette.primary.main,
            opacity: '100%',
        },
        indeterminate: {
            color: theme.palette.primary.main,
            opacity: '100%',
        },
        colorPrimary: {
            '&.Mui-disabled.Mui-checked': {
                color: theme.palette.fill.quaternary,
            },
        },
    });
};
